import { ServiceSelection } from 'reducers/selectedServices';
import { Action } from 'redux';

import {
  CLEAR_SERVICES,
  MAX_APPOINTMENTS_WARNING_ACKNOWLEDGED,
  SELECT_SERVICE,
  UNSELECT_SERVICE,
} from './ActionTypes';

export interface ServiceSelectionAction extends Action {
  type: string;
  payload: ServiceSelection;
}

export function clearServices(): Action {
  return {
    type: CLEAR_SERVICES,
  };
}

export function selectService(
  id: string,
  providerGuid?: string,
  optionId?: string,
  bookingOrder?: number,
): ServiceSelectionAction {
  return {
    type: SELECT_SERVICE,
    payload: {
      guid: id,
      providerGuid,
      optionId,
      bookingOrder,
    },
  };
}

export function unselectService(
  id: string,
  optionId?: string,
): ServiceSelectionAction {
  return {
    type: UNSELECT_SERVICE,
    payload: {
      guid: id,
      optionId,
    },
  };
}

export function hideMaxAppointmentsWarning(
  triggeringServiceGuid?: string,
): Action {
  return {
    type: MAX_APPOINTMENTS_WARNING_ACKNOWLEDGED,
    triggeringServiceGuid,
  } as any;
}
